export const state = () => ({
    countriesList: [],
});

export const mutations = {
    setCountriesList(state, list) {
        state.countriesList = list;
    }
}

export const actions = {
    async setCountriesList({commit}) {
      const currentLocale = this?.$i18n?.locale;

        try {
            const response = await this.$api.agent.transport.get("country?fields=name,slug,icon,icon_id,external_id,popular,synonyms");
            const list = [...(response?.data || [])].map((item) => {
              const synonymsString = item?.synonyms || "";
              let synonymsList = [];
              if (synonymsString) {
                try {
                  synonymsList = String(String(synonymsString || '')).split(' ').filter((t) => !!t).map((t) => String(t || '').toLocaleLowerCase() || '')
                } catch (err) {}
              }

              return {
                ...item,
                synonymsList
              }
            });

            commit('setCountriesList', list);
            return list || [];
        } catch (e) {
            return [];
        }
    }
}

export const getters = {
    countriesList: ({countriesList}) => countriesList,
    isCountriesListLoaded: ({countriesList}) => Boolean(countriesList.length),
}
